import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const Login = () => {
const [username, setUsername] = useState('');
const [password, setPassword] = useState('');
const navigate = useNavigate();

const handleLogin = async (e) => {
e.preventDefault();

try {
const response = await axios.post('https://accessi.sgsmails.com/login.php', {
username: username,
password: password
});

const data = response.data;
if (data.token) {
// Handle successful login, e.g., store token in localStorage
localStorage.setItem('token', data.token);
localStorage.setItem('username', username);
toast.success("Login Successfull");
navigate('/');
} else {
// Handle invalid credentials
console.log(data.error);
toast.error("Username or password is wrong..");
}
} catch (error) {
// Handle error scenarios
console.log(error.response.data);

}
};

return (
<div className='w-full h-screen flex justify-center items-center'>
<form onSubmit={handleLogin}>
<div className="flex flex-col items-center justify-center bg-white px-6 py-8 mx-auto lg:py-0 sm:max-w-md xl:p-0 backdrop-filter backdrop-blur-sm bg-opacity-60 rounded-md">
<div className="p-6 space-y-4 md:space-y-6 sm:p-8">
<p className="text-2xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
Login
</p>
<div>
<label className="block mb-2 text-sm text-left w-full font-medium text-gray-900">
Username
</label>
<input name='username' value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" id="username" type="text" />
</div>
<div>
<label className="block mb-2 text-left w-full text-sm font-medium text-gray-900">
Password
</label>
<input name='password' value={password} onChange={(e) => setPassword(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" placeholder="••••••••" id="password" type="password" />
</div>
<div className="flex items-start">
<div className="flex items-center h-5">
<input className="w-4 h-4 border rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 border-gray-600 focus:ring-primary-600 ring-offset-gray-800" type="checkbox" aria-describedby="terms" id="terms" />
</div>
<div className="ml-3 text-sm">
<label className="font-light text-gray-700">
Remember Password.
</label>
</div>
</div>
<button type="submit" className="w-full bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center focus:ring-blue-800 text-white">
Login
</button>
</div>
</div>
</form>
<ToastContainer />
</div>
);
};

export default Login;